<div class="tableHeader">
  <dynamicComponentLoader *ngIf="!!dynamicComponent" [dynamicComponent]="dynamicComponent"> </dynamicComponentLoader>
</div>
